import React from 'react';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import CheckIcon from '@material-ui/icons/Check';
import CircularProgress from '@material-ui/core/CircularProgress';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    DatePicker,
    TimePicker
} from '@material-ui/pickers';

import { getTimeZone, couplePronouns } from './common';


const BrideSection = (props) => {
    const { bride_first_name, bride_last_name, bride_email, bride_pronoun, handleChange, formErrors } = props;

    return (
        <React.Fragment>
            <TextField
                fullWidth
                margin="normal"
                onChange={handleChange('bride_first_name')}
                label={`${bride_pronoun} First Name`}
                value={bride_first_name || ''}
                required
            />
            <TextField
                fullWidth
                margin="normal"
                onChange={handleChange('bride_last_name')}
                label={`${bride_pronoun} Last Name`}
                value={bride_last_name || ''}
                required
            />
            <TextField
                error={formErrors.bride_email ? true : false}
                fullWidth
                margin="normal"
                onChange={handleChange('bride_email')}
                label={`${bride_pronoun} Email`}
                value={bride_email || ''}
                required
                helperText={formErrors.bride_email || "This is also your login email address"}
            />
        </React.Fragment>
    )
}

const GroomSection = (props) => {
    const { groom_first_name, groom_last_name, groom_email, groom_pronoun, handleChange, formErrors } = props;

    return (
        <React.Fragment>
            <TextField
                fullWidth
                margin="normal"
                onChange={handleChange('groom_first_name')}
                label={`${groom_pronoun} First Name`}
                value={groom_first_name || ''}
                required
            />
            <TextField
                fullWidth
                margin="normal"
                onChange={handleChange('groom_last_name')}
                label={`${groom_pronoun} Last Name`}
                value={groom_last_name || ''}
                required
            />
            <TextField
                error={formErrors.groom_email ? true : false}
                fullWidth
                margin="normal"
                onChange={handleChange('groom_email')}
                label={`${groom_pronoun} Email`}
                value={groom_email || ''}
                helperText={formErrors.groom_email}
                required
            />
        </React.Fragment>
    )
}

const WeddingSection = (props) => {
    const { location, venue, wedding_colours, wedding_date, wedding_planner_email, gridSize, handleChange } = props;

    const timeZone = getTimeZone(wedding_date);

    return (
        <Grid container spacing={3}>
            <Grid item xs={gridSize}>
                <TextField
                    fullWidth
                    margin="normal"
                    label="Wedding Location"
                    value={location || ''}
                    disabled
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label="Wedding Venue"
                    value={venue || ''}
                    disabled
                />
                <TextField
                    fullWidth
                    margin="normal"
                    onChange={handleChange('wedding_colours')}
                    label="Wedding Colours"
                    value={wedding_colours || ''}
                />
                <TextField
                    fullWidth
                    margin="normal"
                    onChange={handleChange('wedding_planner_email')}
                    label="Wedding Planner Email (if applicable)"
                    value={wedding_planner_email || ''}
                    helperText="Do not use wedding venue contact email"
                />
            </Grid>
            <Grid item xs={gridSize}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DatePicker
                        margin="normal"
                        id="wedding-date"
                        label="Wedding Date"
                        format="MM/dd/yyyy"
                        fullWidth
                        value={wedding_date}
                        disabled
                    />
                    <TimePicker
                        margin="normal"
                        id="time-picker-dialog"
                        label={`Wedding Time (${timeZone.initials})`}
                        fullWidth
                        value={wedding_date}
                        disabled
                    />
                </MuiPickersUtilsProvider>
            </Grid>
        </Grid>
    )
}

const WitnessesSection = (props) => {
    const { witness1, witness2, provinces, gridSize, handleChange } = props;

    return (
        <Grid container spacing={3}>
            <Grid item xs={gridSize}>
                <TextField
                    fullWidth
                    margin="normal"
                    onChange={handleChange('witness1_first_name')}
                    label="Witness 1 First Name"
                    value={witness1.first_name || ''}
                />
                <TextField
                    fullWidth
                    margin="normal"
                    onChange={handleChange('witness1_last_name')}
                    label="Witness 1 Last Name"
                    value={witness1.last_name || ''}
                />
                <TextField
                    fullWidth
                    margin="normal"
                    onChange={handleChange('witness1_address')}
                    label="Witness 1 Address"
                    value={witness1.address || ''}
                />
                <TextField
                    fullWidth
                    margin="normal"
                    onChange={handleChange('witness1_city')}
                    label="Witness 1 City"
                    value={witness1.city || ''}
                />
                <TextField
                    select
                    fullWidth
                    margin="normal"
                    onChange={handleChange('witness1_province')}
                    label="Witness 1 Province"
                    value={witness1.province || ''}
                    SelectProps={{
                        autoWidth: true
                    }}
                >
                    {provinces.map(option => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.province_name}
                        </MenuItem>
                    ))}
                </TextField>
                <TextField
                    fullWidth
                    margin="normal"
                    onChange={handleChange('witness1_postal_code')}
                    label="Witness 1 Postal Code"
                    value={witness1.postal_code || ''}
                />
            </Grid>
            <Grid item xs={gridSize}>
                <TextField
                    fullWidth
                    margin="normal"
                    onChange={handleChange('witness2_first_name')}
                    label="Witness 2 First Name"
                    value={witness2.first_name || ''}
                />
                <TextField
                    fullWidth
                    margin="normal"
                    onChange={handleChange('witness2_last_name')}
                    label="Witness 2 Last Name"
                    value={witness2.last_name || ''}
                />
                <TextField
                    fullWidth
                    margin="normal"
                    onChange={handleChange('witness2_address')}
                    label="Witness 2 Address"
                    value={witness2.address || ''}
                />
                <TextField
                    fullWidth
                    margin="normal"
                    onChange={handleChange('witness2_city')}
                    label="Witness 2 City"
                    value={witness2.city || ''}
                />
                <TextField
                    select
                    fullWidth
                    margin="normal"
                    onChange={handleChange('witness2_province')}
                    label="Witness 2 Province"
                    value={witness2.province || ''}
                    SelectProps={{
                        autoWidth: true
                    }}
                >
                    {provinces.map(option => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.province_name}
                        </MenuItem>
                    ))}
                </TextField>
                <TextField
                    fullWidth
                    margin="normal"
                    onChange={handleChange('witness2_postal_code')}
                    label="Witness 2 Postal Code"
                    value={witness2.postal_code || ''}
                />
            </Grid>
        </Grid>
    )
}


const CoupleProfileForm = (props) => {
    const { couple, provinces, setCouple } = props;

    const witnessDefaults = { first_name: '', last_name: '', city: '', address: '', province: '', postal_code: '' };

    const witness1 = couple.witnesses && couple.witnesses.witness1 ? couple.witnesses.witness1 : witnessDefaults;
    const witness2 = couple.witnesses && couple.witnesses.witness2 ? couple.witnesses.witness2 : witnessDefaults;

    const [savePending, setSavePending] = React.useState(false);
    const [saveComplete, setSaveComplete] = React.useState(false);

    const [formErrors, setFormErrors] = React.useState({});

    const handleSubmit = (event) => {
        const formData = {
            ...state,
            _token: window._token
        };
        new Promise((resolve, reject) => {
            let url = `/api/couples/${couple.id}/profile`;
            setSavePending(true);
            fetch(url, {
                method: 'PUT',
                body: JSON.stringify(formData),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    if (result.success) {
                        setCouple(result.wedding);
                        setSaveComplete(true);
                        setSavePending(false);
                        setFormErrors({});
                        setTimeout(() => {
                            setSaveComplete(false);
                        }, 5000);
                    } else {
                        setSavePending(false);
                        setFormErrors(result.errors);
                    }
                })
                .catch(reason => {
                    setSavePending(false);
                    alert('An error prevented saving. Please refresh the page and try again.');
                })
        });
    }

    const handleChange = name => event => {
        setState({
            ...state,
            [name]: event.target.value,
        })
    }

    const [state, setState] = React.useState({
        bride_first_name: couple.bride_first_name,
        bride_last_name: couple.bride_last_name,
        bride_email: couple.bride_email,
        groom_first_name: couple.groom_first_name,
        groom_last_name: couple.groom_last_name,
        groom_email: couple.groom_email,
        wedding_planner_email: couple.wedding_planner_email,
        location: couple.location,
        venue: couple.venue,
        wedding_colours: couple.wedding_colours,
        wedding_date: new Date(couple.wedding_date*1000),
        witness1_first_name: witness1.first_name,
        witness1_last_name: witness1.last_name,
        witness1_city: witness1.city,
        witness1_address: witness1.address,
        witness1_province: witness1.province,
        witness1_postal_code: witness1.postal_code,
        witness2_first_name: witness2.first_name,
        witness2_last_name: witness2.last_name,
        witness2_city: witness2.city,
        witness2_address: witness2.address,
        witness2_province: witness2.province,
        witness2_postal_code: witness2.postal_code,
    });

    const pronouns = couplePronouns(couple);

    return (
        <form>
            <Box>
                <Typography variant="overline" color="primary" display="block">
                    Your details
                </Typography>
            </Box>
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <BrideSection
                        bride_first_name={state.bride_first_name}
                        bride_last_name={state.bride_last_name}
                        bride_email={state.bride_email}
                        bride_pronoun={pronouns.bride}
                        handleChange={handleChange}
                        formErrors={formErrors}
                    />
                </Grid>
                <Grid item xs={6}>
                    <GroomSection
                        groom_first_name={state.groom_first_name}
                        groom_last_name={state.groom_last_name}
                        groom_email={state.groom_email}
                        groom_pronoun={pronouns.groom}
                        handleChange={handleChange}
                        formErrors={formErrors}
                    />
                </Grid>
            </Grid>

            <Box mt={3}>
                <Typography variant="overline" color="primary" display="block">
                    Wedding details
                </Typography>
            </Box>

            <WeddingSection
                venue={state.venue}
                location={state.location}
                wedding_colours={state.wedding_colours}
                wedding_date={state.wedding_date}
                wedding_planner_email={state.wedding_planner_email}
                handleChange={handleChange}
                gridSize={6}
            />

            <Box mt={3}>
                <Typography variant="overline" color="primary" display="block">
                    Your witnesses
                </Typography>
            </Box>

            <WitnessesSection
                witness1={{
                    first_name: state.witness1_first_name,
                    last_name: state.witness1_last_name,
                    address: state.witness1_address,
                    city: state.witness1_city,
                    province: state.witness1_province,
                    postal_code: state.witness1_postal_code,
                }}
                witness2={{
                    first_name: state.witness2_first_name,
                    last_name: state.witness2_last_name,
                    address: state.witness2_address,
                    city: state.witness2_city,
                    province: state.witness2_province,
                    postal_code: state.witness2_postal_code,
                }}
                provinces={provinces}
                gridSize={6}
                handleChange={handleChange}
            />

            <Box mt={4} mb={3}>
                <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                >
                    <Grid item xs={12} sm={4}>
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth={true}
                            onClick={handleSubmit}
                            disabled={savePending ? true : false}
                            endIcon={savePending ? <CircularProgress size={20} /> : (saveComplete ? <CheckIcon /> : null)}
                        >
                            Save Changes
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </form>
    )
}

export default CoupleProfileForm;
